// removed by extract-text-webpack-plugin
module.exports = {"donutContainer":"donutContainer","infoContainer":"infoContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/RoundChart/style.scss
// module id = 1202
// module chunks = 0